import PaymentOption from '../../models/configs/paymentOption.model'

let storeContent = utils.generateStore({
   PaymentOption,
   payment_options: [],
   showUpload: false,
   showEdit: false,
   selectedPaymentOption: {},
})

export default {
   state: {
      ...storeContent.state
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addPaymentOption(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_
            let is_instruction_valid = true

            if (!payload.instruction || payload.instruction.length < 3 || payload.instruction.length > 5000){
               is_instruction_valid = false
               $notify('warning', 'Valudation Error', `Instructions field is required.`)
            }

            if (await payload.ref.isValid() && is_instruction_valid) {
               await api.fetchEndpointSecure({
                  resource: "registration",
                  action: "add:payment_option",
                  data: {
                     name: data.name,
                     amount_per_card: data.amount_per_card,
                     deposit_per_card: data.deposit_per_card,
                     currency: data.currency,
                     instructions: payload.instruction,
                  },
                  meta_data: {}
               })

               await ctx.dispatch('fetchPaymentOptions')
               $notify('success', 'Payment Option Created', `Payment Option ${data.name} successfully created.`)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async fetchPaymentOptions(ctx) {
         try {
            ctx.commit('show', false)
            let res = await api.fetchEndpointSecure({
               resource: "registration",
               action: "get:payment_options",
               data: {},
               meta_data: {}
            })
            ctx.commit('payment_options', res.result.options)

            EventBus.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
      async editPaymentOption(ctx,payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'registration',
                  action: 'edit:payment_option',
                  data: {
                     id: ctx.getters.selectedPaymentOption._id,
                     name: data.name,
                     amount_per_card: data.amount_per_card,
                     deposit_per_card: data.deposit_per_card,
                     currency: data.currency,
                     instructions: payload.instruction,
                  },
                  meta_data: {}
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchPaymentOptions')
               ctx.commit('showEdit', false)
               $notify('success', 'Payment Option Updated', `Payment Option ${data.name} successfully updated.`,5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deletePaymentOption(ctx,id) {
         try {
            EventBus.$emit('loader:show', true)

            let res = await api.fetchEndpointSecure({
               resource: "registration",
               action: "delete:payment_option",
               data: {
                  id
               },
               meta_data: {}
            })

            $notify('success', 'Payment Option Deleted', `Payment Option ${res.result.option.name} successfully deleted.`)
            await ctx.dispatch('fetchPaymentOptions')
            EventBus.$emit('loader:show', false)
         } catch (err) {
            EventBus.$emit('loader:show', false)
            throw err
         }
      },
      async uploadPaymentOptions(ctx,payload){
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               console.log(data.payment_options[0])
               let bodyFormData = new FormData()
               bodyFormData.append('csv',data.payment_options[0]);
               bodyFormData.append('resource','registration');
               bodyFormData.append('action','add:multiple_payment_options');
               bodyFormData.append('file_action','excel_key');

               ctx.commit('showUpload',false)
               let res = await api.upload(api.parseRoute('/upload'),bodyFormData,'fuel_payment_options');
               await ctx.dispatch('fetchPaymentOptions')
               $notify('success', 'Uploaded Fuel PaymentOptions', res.result.msg,10)
            }
            ctx.commit('loading', false)
         }catch(err){
            ctx.commit('loading', false)
            console.log(err)
            $notify('error', 'Upload Fail', `Upload for ${'fuel_payment_options'} failed. Please Try again Later.`,15)
            throw err;
         }
      },
   }
};